export default __webpack_public_path__ + "static/media/sanifer-white-logo.e7ce6b19.png";